import { useEffect, useState } from 'react';
import './styles/navbar.css'

export default function NavBar() {
    const [open, setOpen] = useState(false);
    const [dark, setDark] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem("darkMode");
        if (saved === "true") {
            document.body.classList.add("dark");
            setDark(true);
        }
    }, []);

    function toggleDark() {
        const enabled = !dark;
        setDark(enabled);
        document.body.classList.toggle("dark", enabled);
        localStorage.setItem("darkMode", enabled);
    }

    return (
        <nav className="navbar">
            <div className="logo"> {/* place holder */}</div>
            <div className={`nav-links ${open ? "open" : ""}`}>
                <a href="#about" onClick={() => setOpen(false)}>About Me</a>
                <a href="#skills" onClick={() => setOpen(false)}>Skills</a>
                <a href="#projects" onClick={() => setOpen(false)}>Projects</a>
                <a href="#contact" onClick={() => setOpen(false)}>Contact</a>
                <a href="/resume.pdf" target="_blank" rel="noopener noreferrer">Resume</a>
            </div>  
            <div className="nav-actions">
                <button className="theme-btn" onClick={toggleDark}>
                {dark ? "☀️" : "🌙"}
                </button>

                <div className="hamburger" onClick={() => setOpen(!open)}>
                    <span />
                    <span />
                    <span />
                </div>
            </div>
        </nav>
    )
}